import type { SupplierWorkforce } from '@tandemone/types'
import { Fragment } from 'react'

import { ProfileEmpty } from './profile-empty'
import { ProfileSection } from './profile-section'

type WorkforceDepartment = {
  label: string
  engineersKey: keyof SupplierWorkforce
  techniciansKey: keyof SupplierWorkforce
}

const WORKFORCE_DEPARTMENTS: ReadonlyArray<WorkforceDepartment> = [
  {
    label: 'Engineering',
    engineersKey: 'engineeringEngineers',
    techniciansKey: 'engineeringTechnicians'
  },
  {
    label: 'Production',
    engineersKey: 'productionEngineers',
    techniciansKey: 'productionTechnicians'
  },
  {
    label: 'Quality Assurance',
    engineersKey: 'qaEngineers',
    techniciansKey: 'qaTechnicians'
  }
]

export function ProfileWorkforce({
  companyName,
  workforce
}: {
  companyName: string
  workforce: SupplierWorkforce | null
}) {
  return (
    <ProfileSection title={`${companyName} Workforce`}>
      {workforce === null ? (
        <ProfileEmpty message='No workforce data submitted.' />
      ) : (
        <div className='flex flex-col gap-5'>
          <div className='flex items-baseline gap-3'>
            <span className='text-4xl font-semibold tabular-nums text-foreground'>
              {workforce.totalEmployees.toLocaleString()}
            </span>
            <span className='text-sm text-muted-foreground'>
              total employees
            </span>
          </div>
          <div className='grid grid-cols-[1fr_auto] [&>*]:py-2 [&>*:nth-child(n+3)]:border-t [&>*:nth-child(n+3)]:border-border'>
            <span className='flex items-center text-sm text-foreground'>
              Corporate staff
            </span>
            <span className='flex items-center justify-end text-right text-sm font-medium tabular-nums text-foreground'>
              {workforce.corporateStaff.toLocaleString()}
            </span>
            {WORKFORCE_DEPARTMENTS.map(dept => {
              const engineers = workforce[dept.engineersKey] as number
              const technicians = workforce[dept.techniciansKey] as number
              const subtotal = engineers + technicians
              return (
                <Fragment key={dept.label}>
                  <span className='flex flex-col justify-center'>
                    <span className='text-sm text-foreground'>
                      {dept.label}
                    </span>
                    <span className='text-[11px] text-muted-foreground'>
                      {engineers.toLocaleString()} engineers ·{' '}
                      {technicians.toLocaleString()} technicians
                    </span>
                  </span>
                  <span className='flex items-center justify-end text-right text-sm font-medium tabular-nums text-foreground'>
                    {subtotal.toLocaleString()}
                  </span>
                </Fragment>
              )
            })}
          </div>
        </div>
      )}
    </ProfileSection>
  )
}
